import { Environment, generateApi } from '@environment';
import { environment as baseEnvironment } from './environment.all';

const environmentOverrides: Partial<Environment> = {
  mode: 'prod',

  useProductionData: true,

  api: generateApi({
    url: 'https://api.usheru.com/rest',
    ushChannel: '0afaf952-c8f3-4f91-afff-d627c10cbc5e',
    user: 'filmone-ssr-api@noemail.com',
    pass: '8QERhZVjcYy8mxj'
  }),

  google: {
    maps_key: 'AIzaSyDZUidGlbVTCPiX2iDQY8x1X_SaYZbenr8'
  }
};

export const environment: Environment = Object.assign({}, baseEnvironment, environmentOverrides);
